import React, { ReactElement, useEffect, useState } from "react";
import { ApiService } from "../../../services/api.service";
import AdminHeader from "../shared/header";
import AdminNav from "../shared/nav";
import Loader from "../../Loader";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

function Categories(): ReactElement {
  const location = useLocation();

  if (location.pathname.includes("Administration")) {
    var el = document.getElementById("MAheader");
    if (el !== null) {
      el.style.display = "none";
    }
  }

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    formState: { errors },
  } = useForm();
  const [cats, setCats] = useState<any | null>(null);

  const apiService = new ApiService();

  const [isError, setIsError] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchCats = async () => {
    setLoading(true);
    const response = await apiService.getCategories();
    setCats(response);
    setLoading(false);
  };

  const handleInputChange = (index: any, event: any, categoryID: any) => {
    const values: any = [...cats];

    const updatedValue = event.target.name;

    values[index][updatedValue] = event.target.value;
    values[index]["categoryID"] = categoryID;
    setCats(values);
  };

  const onSubmit = (data: any) => {
    setLoading(true);
    PostData(cats);
  };

  const PostData = async (data: any) => {
    const response = await apiService.PostData(
      "api/Category/SaveCategories",
      data
    );

    if (response === 1) {
      setIsError(1);
      setTimeout(() => setIsError(0), 3000);
      setLoading(false);
      fetchCats();
    } else {
      setIsError(2);
      setTimeout(() => setIsError(0), 3000);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCats();
  }, []);

  return (
    <div>
      <AdminHeader></AdminHeader>
      <div className="container-fluid">
        <div className="row">
          <AdminNav></AdminNav>
          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
              <h1 className="h2">Categories</h1>
            </div>

            {loading ? (
              <Loader />
            ) : (
              <div className="table-responsive">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Category</th>
                        <th scope="col">Show</th>
                        <th scope="col">Main Area</th>
                        <th scope="col">Edit Sub Cats</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cats &&
                        cats.map((item: any, index: number) => (
                          <tr>
                            <td>{item.categoryID}</td>
                            <td>
                              <input
                                type="text"
                                name="categoryName"
                                defaultValue={item.categoryName}
                                onChange={(event: any) =>
                                  handleInputChange(
                                    index,
                                    event,
                                    item.categoryID
                                  )
                                }
                              />
                            </td>
                            <td>
                              <div className="form-check">
                                <select
                                  className="form-select"
                                  id="country"
                                  name="show"
                                  onChange={(event: any) =>
                                    handleInputChange(
                                      index,
                                      event,
                                      item.categoryID
                                    )
                                  }
                                >
                                  <option value="1" selected={1 === item.show}>
                                    Live
                                  </option>
                                  <option value="3" selected={3 === item.show}>
                                    Archived
                                  </option>
                                </select>
                              </div>
                            </td>

                            <td>
                              <div className="form-check">
                                <select
                                  className="form-select"
                                  id="country"
                                  name="homepageShow"
                                  onChange={(event: any) =>
                                    handleInputChange(
                                      index,
                                      event,
                                      item.categoryID
                                    )
                                  }
                                >
                                  <option
                                    value="1"
                                    selected={1 === item.homepageShow}
                                  >
                                    Yes
                                  </option>
                                  <option
                                    value="0"
                                    selected={
                                      0 === item.homepageShow ||
                                      null === item.homepageShow
                                    }
                                  >
                                    No
                                  </option>
                                </select>
                              </div>
                            </td>
                            <td>
                              <Link
                                style={{ textDecoration: "none" }}
                                to={`../Administration/SubCategories/?id=${item.categoryGuid}`}
                              >
                                Edit Sub Cat
                              </Link>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  <button
                    type="submit"
                    className="btn btn-fill-out btn-block hover-up"
                    name="login"
                  >
                    Save Categories
                  </button>
                  <Link
                    style={{ textDecoration: "none", marginLeft: "10px" }}
                    to={`../Administration/Categories/Add-Category`}
                    className="btn btn-fill-out btn-block hover-up"
                  >
                    Add new category
                  </Link>
                  <span
                    className={`badge badge-pill badge ${
                      isError === 2 ? "red" : isError === 1 ? "green" : ""
                    } `}
                  >
                    {isError === 2 ? "Error" : isError === 1 ? "Saved" : ""}
                  </span>
                </form>
              </div>
            )}
          </main>
        </div>
      </div>
    </div>
  );
}
export default Categories;
